/**
 * Supabase Client Configuration
 *
 * Used for feedback system and other backend services
 * Note: Authentication is handled by Firebase, Supabase is used for database only
 */

import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check .env.local');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    // Disable Supabase auth since we're using Firebase
    autoRefreshToken: false,
    persistSession: false,
  },
});
